import { useTranslation } from 'react-i18next'

import * as styles from './EmailPrinterNotificationActions.module.css'

function EmailPrinterNotificationActions(props) {
  const { canSendToPrinter } = props

  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      {canSendToPrinter ? (
        <span className={styles.action} onClick={props.onSendToPrinter}>
          {t('Email.SendToPrinterNoEmailUsersKey')}
        </span>
      ) : null}
      {canSendToPrinter ? (
        <span className={styles.separator}>{t('Email.OrActionKey')}</span>
      ) : null}
      <span className={styles.action} onClick={props.onRemoveAccounts}>
        {t('Email.RemoveNoEmailUsersKey')}
      </span>
    </div>
  )
}

export default EmailPrinterNotificationActions
